import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Search, Trash2 } from 'lucide-react';

interface AgentFacilityFiltersProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
  selectedCount: number;
  onBulkRemove: () => void;
  isBulkRemoving: boolean;
}

export function AgentFacilityFilters({
  searchTerm,
  onSearchChange,
  selectedCount,
  onBulkRemove,
  isBulkRemoving,
}: AgentFacilityFiltersProps) {
  return (
    <div className="flex items-center justify-between gap-4 mb-4">
      <div className="relative flex-1 max-w-sm">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground h-4 w-4" />
        <Input
          placeholder="Search agents, facilities..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-10"
        />
      </div>
      {selectedCount > 0 && (
        <div className="flex gap-2">
          <Badge variant="secondary">{selectedCount} selected</Badge>
          <Button variant="destructive" size="sm" onClick={onBulkRemove} disabled={isBulkRemoving}>
            <Trash2 className="h-4 w-4 mr-1" />
            Remove Selected
          </Button>
        </div>
      )}
    </div>
  );
}
